module.exports = __webpack_public_path__ + "img/zyrzlgw.92a4a149.png";